import React from 'react';
import { Tab, Segment, Header, Message } from 'semantic-ui-react';
import {
  Items,
  Timetable,
  SimpleTimetable,
  RoundRobinTable,
  FolkraceTable
} from './Tables';


const ScheduleTab = (props) => {
  let panes = [],
      { data, loading, title, noDataText, competition: c, isAdmin } = props,
      hasData = !!(data && data.length);

  if (hasData) {
    if (c) {
      if (c.competitionType === 'FOLKRACE') {
        panes.push({
          menuItem: 'Folkrace schedule',
          render: () =>
            <Tab.Pane loading={loading}>
              <FolkraceTable data={data} editable={isAdmin}/>
            </Tab.Pane>
        });
      } else if (c.competitionType === 'RRT_DE') {
        panes.push({
          menuItem: 'Round Robin Schedule',
          render: () =>
            <Tab.Pane loading={loading}>
              <RoundRobinTable data={data} editable={isAdmin}/>
            </Tab.Pane>
        });
      } else {
        panes.push({
          menuItem: 'Points/timetable Schedule',
          render: () =>
            <Tab.Pane loading={loading}>
              <SimpleTimetable data={data} columns={c.attemptsLimit} editable={isAdmin}/>
            </Tab.Pane>
        });
      }
    }

    if (isAdmin) {
      panes.push({
        menuItem: 'Timetable',
        render: () =>
          <Tab.Pane loading={loading}>
            <Timetable data={data}/>
          </Tab.Pane>
      });

      panes.push({
        menuItem: 'Database Items',
        render: () =>
          <Tab.Pane loading={loading}>
            <Items data={data}/>
          </Tab.Pane>
      });
    }
  }

  return (
    <Segment>
      <Header as='h5'>{title}</Header>
      { hasData && <Tab panes={panes}/>}
      { !hasData && <Message header='No data' content={noDataText}/>}
    </Segment>
  );
};

export default ScheduleTab;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/Tab.js